var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 h-6 rounded-full text-xs font-semibold flex items-center",class:[
    _vm.color === 'red' ? 'bg-red-100 text-red-700': '',
    _vm.color === 'yellow' ? 'bg-yellow-100 text-yellow-700': '',
    _vm.color === 'blue' ? 'bg-blue-100 text-blue-700': '' ]},[_c('span',{staticClass:"w-2 h-2 rounded-full mr-1",class:[
    _vm.color === 'red' ? 'bg-red-400': '',
    _vm.color === 'yellow' ? 'bg-yellow-400': '',
    _vm.color === 'blue' ? 'bg-blue-400': '' ]}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }